import dynamic from 'next/dynamic';
import { settings } from './experiments';
import type { Experiments } from './experiments';

const ExperimentProvider = dynamic(() =>
  import('@carvana/experiment').then(mod => mod.ExperimentProvider)
);

type OwnProps = {
  children: React.ReactNode;
  preloadedExperiments: Partial<Experiments>;
};

function CvtExperimentProvider({ children, preloadedExperiments }: OwnProps) {
  return (
    <ExperimentProvider defaults={settings} preloadedExperiments={preloadedExperiments}>
      {children}
    </ExperimentProvider>
  );
}

export default CvtExperimentProvider;
